import { Injectable } from '@angular/core';
import { ContentItem } from '@edassist/api';
import { AppConfigService } from '../../app-config/app-config.service';
import { constants } from '../../constants/constants';
import { LodashUtilityService } from '../utility/lodash-utility-service';

@Injectable({ providedIn: 'root' })
export class GeneralContentService {
	static mapContent(contentItems: Array<ContentItem>): any {
		return LodashUtilityService.mapValues(LodashUtilityService.groupBy(contentItems, 'name'), (item) => {
			const content = item.map((dataItem) => {
				if (dataItem.fileName) {
					return {
						fileName: dataItem.fileName,
						id: dataItem.id,
						fileId: dataItem.fileId,
						filePath: dataItem.filePath,
						title: dataItem.title,
						data: dataItem.data,
						sequence: dataItem.sequence,
						name: dataItem.name,
						fullCdnFilePath: `${AppConfigService.getSettings().endPoints.cdn}${dataItem.filePath}`
					};
				}
				if (dataItem.altData) {
					return { text: dataItem.data, altData: dataItem.altData };
				}

				if (dataItem.title) {
					return {
						id: dataItem.id,
						text: dataItem.data,
						title: dataItem.title,
						startDate: dataItem.startDate,
						endDate: dataItem.endDate
					};
				}

				return dataItem.data;
			});

			return content.length > 1 ? content : content[0];
		});
	}

	static isContentItemGlobal(contentItems: Array<ContentItem>, contentName: string): boolean {
		return (
			contentItems.find((contentItem) => contentItem.name === contentName)?.client ===
			constants.contentConstants.contentTypes.global
		);
	}
}
